(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play-context/assets/javascripts/play-context.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play-context/assets/javascripts/play-context.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  createContext,
  useCallback,
  useEffect,
  useReducer,
  useState
} = React;
const withRouter = svs.app.ReactRouter.withRouter;
const raceNoLongerOpen = svs.racing.common.statusUtil.raceNoLongerOpen;
const {
  gameTypeHasSystem
} = svs.racing.common.util;
const {
  systemTypes,
  gameTypes,
  couponMenuItems
} = svs.racing.common.constants;
const {
  actions,
  reducer
} = svs.racing_game.components.playContext;
const {
  fetchRace
} = svs.racing.raceService;
const useGameEngine = svs.racing.useGameEngine;
const {
  useNavigationState
} = svs.racing.navigation;
const {
  buildLocation
} = svs.racing.navigation.location;
const {
  useHistory
} = ReactRouterDOM;
const logger = svs.core.log.getLogger('racing_game.components.playContext');
const PlayContext = createContext();
const getIsSystemEngine = navigation => navigation.isSystem && gameTypeHasSystem(navigation.gameType) && !navigation.isXpert;
const PlayProvider = _ref => {
  let {
    children
  } = _ref;
  const [raceData, raceDataDispatch] = useReducer(reducer, svs.racing_game.data ? svs.racing_game.data.race : undefined);
  const [shouldApplyRow, setShouldApplyRow] = useState(undefined);

  useEffect(() => {
    svs.racing_game.data.race = raceData;
  }, [raceData]);
  const engine = useGameEngine();
  const navigation = useNavigationState();
  const history = useHistory();

  useEffect(() => {
    if (raceData && (navigation.gameType || raceNoLongerOpen(raceData))) {
      if (navigation.gameType === gameTypes.RX3AO && (navigation.isXpert || navigation.couponMenuItem === couponMenuItems.PIX)) {
        engine.initialize(navigation.gameType, true, raceData);
      } else {
        engine.initialize(navigation.gameType, getIsSystemEngine(navigation), raceData, navigation.pixMode);
      }
    }
  }, [raceData, navigation.gameType, navigation.isSystem, navigation.isXpert, navigation.pixMode, navigation.couponMenuItem]);
  useEffect(() => {
    const isNavigationDefined = Boolean(navigation.day && navigation.trackName && navigation.raceNumber);
    const isNavigationDifferent = Boolean(raceData && (navigation.day !== raceData.meeting.formattedDate || navigation.trackName !== raceData.meeting.track.urlName || parseInt(navigation.raceNumber, 10) !== raceData.raceNumber));
    const rowToApply = navigation.row;
    if (isNavigationDefined && isNavigationDifferent || isNavigationDefined && !raceData) {
      raceDataDispatch(actions.setRace(undefined));
      engine.reset();
      fetchRace(navigation.day, navigation.trackName, navigation.raceNumber, (err, race) => {
        if (err) {
          logger.error("fetchRace-error: ".concat(err));
        } else {
          raceDataDispatch(actions.setRace(race));
          setShouldApplyRow(rowToApply);
        }
      });
    } else if (rowToApply) {
      setShouldApplyRow(rowToApply);
    }
  }, [navigation.day, navigation.trackName, navigation.raceNumber, navigation.row]);
  const tryApplyRow = useCallback(row => {
    if (row && engine.isReady) {
      setShouldApplyRow(undefined);
      if (engine.systemType === systemTypes.TOP_RANK_PIX) {
        engine.actions.clearRow();
      } else {
        engine.actions.clearAll();
      }
      const parsedRow = row.split(',').map(item => parseInt(item, 10));
      const data = {
        anyOrder: false,
        pixSize: 0,
        qpValue: 'no-qp',
        row: parsedRow
      };
      engine.actions.trySetData(data);

      const newLocation = buildLocation(_objectSpread(_objectSpread({}, navigation), {}, {
        row: undefined
      }));
      history.replace(newLocation);
    }
  }, [navigation, engine.actions, engine.isReady, history]);

  useEffect(() => {
    if (shouldApplyRow) {
      tryApplyRow(shouldApplyRow);
    }
  }, [shouldApplyRow]);
  return React.createElement(PlayContext.Provider, {
    value: {
      engine,
      race: raceData,
      raceDispatch: raceDataDispatch
    }
  }, children);
};
svs.racing_game.components.playContext.PlayContext = PlayContext;
svs.racing_game.components.playContext.PlayProvider = withRouter(PlayProvider);

 })(window);